import React, {useMemo, useRef, useState} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import Modal from '@material-ui/core/Modal';

import {Notify} from '../NOTIFY/NotifyModel'

import {apollo_useRowStyles, apollo_useStyles} from "../../atom/Apollo_styles";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from '@material-ui/core/Tooltip';
import {Info} from "../NOTIFY/NotifyModel";
import {
  apollo_relation_info_path,
} from "../../atom/Apollo_links";
import {ApolloContext} from "../../atom/Apollo_Context";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import moment from "moment";
import Collapse from "@material-ui/core/Collapse";
import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Badge from "@material-ui/core/Badge";
import classNames from "classnames";
import {DeleteButton} from "../../molecule/Apollo_Button";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import * as colors from "@material-ui/core/colors";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
// メッセージ定義
import {
  GetMessage,
  UI_NOTIFY_CLIENT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 40;
  const left = 42;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

export const NotificationModal = () => {

  const classes = apollo_useStyles();
  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [row, setRow] = useState<Notify>({
    infoList: [],
    unreadCount: 0,
  });

  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const processing = useRef(false);
  // 操作ログ仕様変数
  const resultApi = useRef(-1);
  const logTime = useRef("");
  const actionType = useRef(0); // 0:参照 1:新規 2:更新 3:削除 4:アップロード
  const targetId = useRef(0);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = (infoId: number, idx: number) => {
    if (processing.current) return;
    processing.current = true;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログアクション(削除)
    actionType.current = 3;
    // ターゲットIDセット
    targetId.current = infoId;
    writeLog();

    const url = `${apollo_relation_info_path}/${infoId}`;
    ApolloAxios.delete(url).then(response => {
      // 操作ログ(成功)
      resultApi.current = 1;
      row.infoList?.splice(idx, 1);
      setRow({
        ...row,
        infoList: row.infoList,
      })
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      console.log(err)
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_CLIENT,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  }

  useMemo(() => {
    if(open) return;
    // 毎画面表示時に通知メッセージの受信状況を取得
    ApolloAxios.get(apollo_relation_info_path).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        // if(res?.message.match("404") !== null) return;
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : GetMessage("0",UI_NOTIFY_CLIENT,"E","3"),
        });
      }
      setRow(res.result);
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_CLIENT,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  },[open]);

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    var key = "";
    var beforeValue = "";
    var afterValue = "";
    switch (actionType.current) {
      case 0: // 参照
        break;
      case 1: // 新規
        break;
      case 2: // 更新
        break;
      case 3: // 削除
        key = "論理削除フラグ";
        beforeValue = "0";
        afterValue = "1";
        break;
      case 4: // アップロード
        break;
      default: // 不明
        key = "不明";
    }
    // 項目リスト
    const itemList: ItemList[] = [];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: state.current.accountId, // 広告主アカウントID
      accountName: state.current.accountName, // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "通知メッセージ画面", // 操作画面名称 〇〇画面
      category: "メッセージ", // 操作対象 キャンペーン / セグメント etc...
      actionType: actionType.current === 0 ? "参照" : actionType.current === 1 ? "作成" : actionType.current === 2 ? "更新" : actionType.current === 3 ? "削除" : actionType.current === 4 ? "アップロード" : "不明", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : targetId.current + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "メッセージID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  function getMuiTheme() { return createMuiTheme({
    palette: {
      primary: {
        main: colors.blue[300],
        light: '#fff',
        contrastText: '#fff',
      },
    },
    overrides: {
      MuiPopover: {
        paper: {
          Width: "300px",
        }
      },
      MuiTableCell: {
        root: {
          padding: "none",
        },
      },
    } } )};

  return (
    <div>
      <Tooltip title="通知メッセージ" placement="bottom">
        <IconButton aria-label="" color="inherit" onClick={handleOpen}>
          <Badge color="secondary" badgeContent={row?.unreadCount} max={99}>
            <img src={"/icon/header_03.png"} alt="notification" height="auto" width="25"/>
          </Badge>
        </IconButton>
      </Tooltip>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div style={modalStyle} className={classes.paperNotify}>
          <div className={classes.tableScrollContainer} >
          <ThemeProvider  theme={ getMuiTheme()} >
           <React.Fragment>
              <TableContainer component={Paper} square variant="outlined" style={{maxHeight: 550}}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell> </TableCell>
                      <TableCell align="left">タイトル</TableCell>
                      <TableCell align="left">掲載日時</TableCell>
                      <TableCell> </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.infoList ?
                      row.infoList?.map((row, idx) => (
                        <Row key={row.infoId} row={row} idx={idx} handleDelete={handleDelete}/>
                      ))
                      :
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>メッセージはありません</TableCell>
                        <TableCell> </TableCell>
                        <TableCell> </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </React.Fragment>
            </ThemeProvider>
          </div>
        </div>
      </Modal>
    </div>
  );
};

/*
    テーブルデータ表示
 */
function Row(props: { row: Info, idx: number, handleDelete: any }) {
  const {row, idx, handleDelete} = props;
  const {data, setmsg} = React.useContext(ApolloMessage);
  const classes = apollo_useRowStyles();
  const [open, setOpen] = useState<boolean>(false);
  const [invisible, setInvisible] = useState<boolean>(row.isViewed);
  const even = (idx + 1) % 2 === 0 ? classes.even : "";
  const tableRowClass = classNames(classes.root, even);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const handleOpen = (infoId: number, open: boolean, invisible: boolean) => {
    setOpen(!open);
    if (!invisible) {
      const url = `${apollo_relation_info_path}/${infoId}`;
      ApolloAxios.put(url).then(response => {
        setInvisible(true);
      }).catch(err => {
        console.log(err)
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_CLIENT,"E","2"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
  }

  return (
    <React.Fragment>
      <TableRow className={tableRowClass}>
        <TableCell>
          <Badge color="primary" badgeContent="" invisible={invisible}>
            <IconButton aria-label="expand row" size="small" onClick={() => handleOpen(row.infoId, open, invisible)}>
              {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
            </IconButton>
          </Badge>
        </TableCell>
        <TableCell align="left">{row.infoName}</TableCell>
        <TableCell align="left">{moment(row.startAt).format("YYYY-MM-DD HH:mm")}</TableCell>
        <TableCell align="left">
          <DeleteButton handleDelete={() => handleDelete(row.infoId, idx)} title="メッセージ削除" text={`このメッセージを削除しますか？`}/>
        </TableCell>
      </TableRow>
      <TableRow key={row.infoId} className={even}>
        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="purchases">
                <TableBody>
                  <TableRow>
                    <TableCell align="left" style={{whiteSpace: "pre-line"}}>{row.infoText}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
